var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMenuDocuments(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.729,
    height: 15.551,
    viewBox: "0 0 12.729 15.551",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file_1_",
    "data-name": "file (1)",
    transform: "translate(-86.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10322",
    "data-name": "Path 10322",
    d: "M207.772,108.4h-.455v11.171a1.348,1.348,0,0,1-1.346,1.346H197.7v.414a.859.859,0,0,0,.859.859h9.211a.859.859,0,0,0,.859-.859V109.259A.858.858,0,0,0,207.772,108.4Z",
    transform: "translate(-109.001 -106.64)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10323",
    "data-name": "Path 10323",
    d: "M92.363,13.791h4.606a.859.859,0,0,0,.859-.859V.859A.859.859,0,0,0,96.969,0H90.832V.284a.836.836,0,0,1,0,.091V2.728a1.211,1.211,0,0,1-1.21,1.21H87.274c-.024,0-.05,0-.075,0h-.3v9a.859.859,0,0,0,.859.859h4.6Zm.174-2.92h-3a.406.406,0,0,1,0-.812h3a.406.406,0,1,1,0,.812Zm3-2.072H89.534a.406.406,0,0,1,0-.812h6.007a.406.406,0,1,1,0,.812ZM89.534,5.786h6.007a.406.406,0,1,1,0,.812H89.534a.406.406,0,0,1,0-.812Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10324",
    "data-name": "Path 10324",
    d: "M87.909,4.238h2.36a.721.721,0,0,0,.715-.715V1.162A.362.362,0,0,0,90.619.8a.352.352,0,0,0-.253.107L87.652,3.621A.362.362,0,0,0,87.909,4.238Z",
    transform: "translate(-0.635 -0.787)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuDocuments);
export default __webpack_public_path__ + "static/media/icon-menu-documents.7862df35738448a7366b024a1d81082a.svg";
export { ForwardRef as ReactComponent };